import { combineValidators, isRequired } from "revalidate";

export const fields = ["phone"];

export const validate = combineValidators({
	phone: isRequired({
		message: { id: "error.phone.required" },
	}),
});
